/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GrantPK } from './GrantPK';
import {
    GrantPKFromJSON,
    GrantPKFromJSONTyped,
    GrantPKToJSON,
} from './GrantPK';

/**
 * 
 * @export
 * @interface AddLarsRecipientDto
 */
export interface AddLarsRecipientDto {
    /**
     * 
     * @type {Array<GrantPK>}
     * @memberof AddLarsRecipientDto
     */
    newLarIds?: Array<GrantPK>;
    /**
     * Workflow task actor id that is used for this operation
     * @type {string}
     * @memberof AddLarsRecipientDto
     */
    workflowInstanceAssignedTaskId?: string;
}

/**
 * Check if a given object implements the AddLarsRecipientDto interface.
 */
export function instanceOfAddLarsRecipientDto(value: object): boolean {
    return true;
}

export function AddLarsRecipientDtoFromJSON(json: any): AddLarsRecipientDto {
    return AddLarsRecipientDtoFromJSONTyped(json, false);
}

export function AddLarsRecipientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddLarsRecipientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'newLarIds': json['newLarIds'] == null ? undefined : ((json['newLarIds'] as Array<any>).map(GrantPKFromJSON)),
        'workflowInstanceAssignedTaskId': json['workflowInstanceAssignedTaskId'] == null ? undefined : json['workflowInstanceAssignedTaskId'],
    };
}

export function AddLarsRecipientDtoToJSON(value?: AddLarsRecipientDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'newLarIds': value['newLarIds'] == null ? undefined : ((value['newLarIds'] as Array<any>).map(GrantPKToJSON)),
        'workflowInstanceAssignedTaskId': value['workflowInstanceAssignedTaskId'],
    };
}

